import { render, staticRenderFns } from "./SharingTokensTable.vue?vue&type=template&id=4e1c9ff8&scoped=true&"
import script from "./SharingTokensTable.vue?vue&type=script&lang=js&"
export * from "./SharingTokensTable.vue?vue&type=script&lang=js&"
import style0 from "./SharingTokensTable.vue?vue&type=style&index=0&id=4e1c9ff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c9ff8",
  null
  
)

/* custom blocks */
import block0 from "./SharingTokensTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports